(() => {
  const body = document.body;
  if (!body.classList.contains('template-index')) return;
  if (document.querySelector('[data-remie-home]')) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const heroSlider = document.querySelector('.template-index [data-wetheme-section-type="image--slideshow"]');
  if (!heroSlider) return;

  const heroSection = heroSlider.closest('.section--slideshow-wrapper') || heroSlider.parentElement;
  if (!heroSection) return;

  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));
  const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);
  const easeInOutCubic = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);

  let pinDistance = 0;
  let hasUserScrolled = false;

  const getActiveSlide = () =>
    heroSlider.querySelector('.homepage-sections--slideshow-wrapper.swiper-slide-active') ||
    heroSlider.querySelector('.homepage-sections--slideshow-wrapper');

  const applyPinLayout = () => {
    pinDistance = Math.max(Math.round(window.innerHeight * 1.8), 1400);

    heroSection.classList.add('nuset-hero-pinned');
    heroSlider.classList.add('nuset-hero-pinned');
    body.classList.add('hero-scroll-active');
    body.classList.add('hero-scroll-mounted');
    heroSection.style.minHeight = `${window.innerHeight + pinDistance}px`;
    heroSection.style.setProperty('--nuset-hero-pin-distance', `${pinDistance}px`);
    heroSlider.style.position = 'sticky';
    heroSlider.style.top = '0';
    heroSlider.style.height = '100vh';
    heroSlider.style.overflow = 'hidden';
    heroSlider.style.zIndex = '1';
  };

  const getHeroProgress = () => {
    if (prefersReducedMotion) return 0;
    const rect = heroSection.getBoundingClientRect();
    return clamp((-rect.top) / pinDistance, 0, 1);
  };

  const clearNonActiveSlides = () => {
    const slides = heroSlider.querySelectorAll('.homepage-sections--slideshow-wrapper');
    const active = getActiveSlide();
    slides.forEach((slide) => {
      if (slide === active) return;
      slide.querySelectorAll(
        '.slideshow-title-container, .slideshow-text-container, .slideshow-image-overlay, .slideshow-desktop-image, .slideshow-mobile-image, .slideshow-desktop-as-mobile-image'
      ).forEach((el) => {
        el.style.opacity = '';
        el.style.transform = '';
        el.style.filter = '';
      });

    });
  };

  const updateHero = (progress) => {
    if (prefersReducedMotion) return;
    const active = getActiveSlide();
    if (!active) return;

    clearNonActiveSlides();

    const revealPhase = clamp((progress - 0.02) / 0.28, 0, 1);
    const revealEase = easeInOutCubic(revealPhase);
    const fadePhase = clamp((progress - 0.58) / 0.28, 0, 1);
    const fadeEase = easeInOutCubic(fadePhase);

    const title = active.querySelector('.slideshow-title-container');
    const text = active.querySelector('.slideshow-text-container');
    const overlay = active.querySelector('.slideshow-image-overlay');

    if (title) {
      title.style.opacity = String(revealEase);
      title.style.transform = `translate3d(0, ${24 - revealEase * 24}px, 0)`;
    }

    if (text) {
      text.style.opacity = String(revealEase);
      text.style.transform = `translate3d(0, ${28 - revealEase * 28}px, 0)`;
    }

    if (overlay) {
      overlay.style.opacity = String(0.72 + fadeEase * 0.28);
      overlay.style.filter = `brightness(${1 + fadeEase * 0.08}) blur(${fadeEase * 1.1}px)`;
      overlay.style.background = `rgba(234, 217, 203, ${0.35 + fadeEase * 0.65})`;
    }

    active
      .querySelectorAll('.slideshow-desktop-image, .slideshow-mobile-image, .slideshow-desktop-as-mobile-image')
      .forEach((media) => {
        const scale = 1 + fadeEase * 0.025;
        const y = fadeEase * 12;
        media.style.opacity = String(1 - fadeEase);
        media.style.transform = `translate3d(0, ${y}px, 0) scale(${scale})`;
        media.style.filter = `brightness(${1 + fadeEase * 0.02})`;
      });

    body.classList.toggle('hero-at-top', progress < 0.9);
  };

  const parallaxTargets = [];
  const installParallax = () => {
    if (prefersReducedMotion) return;
    const selector = [
      '.template-index [data-wetheme-section-id="image_with_text_manifesto"] .feature_row__image_wrapper',
      '.template-index [data-wetheme-section-id="image_with_text_user_voice"] .feature_row__image_wrapper',
      '.template-index [data-wetheme-section-id="gallery_topics"] .homepage-gallery-grid-item .grid-image img',
      '.template-index [data-wetheme-section-id="featured_collection_conversion"] .grid-view-item-image img'
    ].join(', ');
    document.querySelectorAll(selector).forEach((el) => {
      el.classList.add('nuset-parallax');
      parallaxTargets.push(el);
    });
  };

  const updateParallax = () => {
    if (prefersReducedMotion) return;
    const vh = window.innerHeight || document.documentElement.clientHeight;
    parallaxTargets.forEach((el) => {
      const rect = el.getBoundingClientRect();
      const center = rect.top + rect.height / 2;
      const offset = (center - vh / 2) / vh;
      const shift = clamp(offset * -34, -34, 34);
      el.style.transform = `translate3d(0, ${shift}px, 0)`;
    });
  };

  const installSectionReveal = () => {
    if (prefersReducedMotion) return;
    const sections = document.querySelectorAll('.template-index [data-wetheme-section-type]:not([data-wetheme-section-type="image--slideshow"])');
    if (!sections.length) return;
    body.classList.add('nuset-scroll-ready');
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('nuset-inview');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -10% 0px' }
    );
    sections.forEach((s) => io.observe(s));
  };

  let ticking = false;
  const tick = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      updateHero(getHeroProgress());
      updateParallax();
      ticking = false;
    });
  };

  applyPinLayout();
  installSectionReveal();
  installParallax();

  window.addEventListener('scroll', () => {
    if (!hasUserScrolled && (window.scrollY || window.pageYOffset || 0) > 8) {
      hasUserScrolled = true;
    }
    tick();
  }, { passive: true });
  window.addEventListener('resize', () => {
    applyPinLayout();
    tick();
  }, { passive: true });
  window.addEventListener('orientationchange', () => {
    applyPinLayout();
    tick();
  }, { passive: true });

  const mo = new MutationObserver(tick);
  mo.observe(heroSlider, { subtree: true, attributes: true, attributeFilter: ['class'] });

  tick();
})();
